import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

gsap.registerPlugin(ScrollTrigger, SplitText)

function initHighlightText() {
    let splitHeadingTargets = document.querySelectorAll('.js-quote')

    let mm = gsap.matchMedia()

    mm.add('(min-width: 1024px)', () => {
        splitHeadingTargets.forEach((heading) => {
            const scrollStart =
                heading.getAttribute('data-highlight-scroll-start') || 'top 90%'
            const scrollEnd =
                heading.getAttribute('data-highlight-scroll-end') ||
                'center 60%'
            const blurValue =
                Number(heading.getAttribute('data-highlight-blur')) || 15 // px
            const staggerValue =
                Number(heading.getAttribute('data-highlight-stagger')) || 0.1

            new SplitText(heading, {
                type: 'words, chars',
                autoSplit: true,
                onSplit(self) {
                    let ctx = gsap.context(() => {
                        // nodig voor per-letter filter rendering
                        gsap.set(self.chars, { display: 'inline-block' })

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                scrub: true,
                                trigger: heading,
                                start: scrollStart,
                                end: scrollEnd
                                // markers: true
                            }
                        })

                        tl.fromTo(
                            self.chars,
                            { filter: `blur(${blurValue}px)` },
                            {
                                filter: 'blur(0px)',
                                stagger: staggerValue,
                                ease: 'linear'
                            }
                        )
                    }, heading)

                    return ctx
                }
            })
        })

        return () => {
            // optional
            // custom cleanup code here (runs when it STOPS matching)
        }
    })
}

document.addEventListener('DOMContentLoaded', initHighlightText)
